// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import OperationsFormController from "./operations_form_controller"
application.register("operations-form", OperationsFormController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)
